import { ILookDetail, ILookJournalPost } from '../components/types'
import { lookbook_item_item } from '../__generated__/lookbook_item'
import { getPropByCode } from './gql'
import { getImageSrc } from './utils'
import { ProductType } from '../__generated__/globalTypes'

export const createLookBookDetailData = (
  element: lookbook_item_item,
): ILookDetail => {
  const now = new Date().getTime()
  const filteredElems = element.propertyValuesRelation
    ?.filter((elem) =>
      elem.property?.code === 'PRODUCTS' ? elem.targetElements : null,
    )[0]
    ?.targetElements?.filter((el) => {
      if (el.active) {
        if (el.activeFrom && el.activeTo) {
          const from = new Date(el.activeFrom).getTime()
          const to = new Date(el.activeTo).getTime()

          return now >= from && now <= to
        } else if (el.activeFrom && !el.activeTo) {
          const from = new Date(el.activeFrom).getTime()

          return now >= from
        } else if (!el.activeFrom && el.activeTo) {
          const to = new Date(el.activeTo).getTime()

          return now <= to
        }

        return true
      } else {
        return false
      }
    })

  //journal block
  const video = getPropByCode(element.propertyValues, 'YOUTUBE')
  const videoTitle = getPropByCode(element.propertyValues, 'YOUTUBE_NAME')
  const post = element.propertyValuesRelation?.filter(
    (elem) => elem.property?.code === 'ARTICLE',
  )[0]

  const journal: ILookJournalPost = {
    name: null,
    videoLink: null,
    postLink: null,
  }

  if (post) {
    journal.name = post.targetElement?.name
    journal.postLink = `/journal/${post.targetElement?.sections[0]?.code}/${post?.targetElement?.code}`
  }

  if (video) {
    journal.videoLink = video
  }

  if (!post && videoTitle) {
    journal.name = videoTitle
  }

  if (!post && !videoTitle) {
    journal.name = element?.name
  }

  return {
    id: element.id,
    name: element.name,
    img: getImageSrc(element.detailPicture?.url),
    structure: filteredElems
      //checking root section activity
      ?.filter((elem) => {
        const parentSections =
          elem.parentProduct?.sections.filter(
            (section) => !!section?.parentSection?.code,
          ) || []

        return (
          parentSections?.length > 0 ||
          elem.parentSection?.active ||
          elem.parentSection?.parentSection?.active
        )
      })
      ?.map((elem) => {
        let link = '/catalog/'
        let name = ''

        if (
          elem.productType === ProductType.SIMPLE &&
          elem.parentSection?.code &&
          elem.parentSection.parentSection.code
        ) {
          link += `${elem.parentSection.parentSection.code}/${elem.parentSection?.code}/${elem.code}`
          name = elem.name
        } else if (elem.productType === ProductType.SKU) {
          const parentProductSection =
            elem.parentProduct &&
            elem.parentProduct?.sections.filter(
              (section) => !!section?.parentSection?.code,
            )[0]

          link += `${parentProductSection?.parentSection?.code}/${parentProductSection?.code}/${elem.parentProduct?.code}?offer=${elem.bx_id}`
          name = elem.parentProduct?.name
        }

        return {
          name,
          subName:
            elem.propertyValuesRelation?.filter(
              (val) => val.property?.code === 'COLOR_REF',
            )[0]?.targetHlElement?.name || '',
          id: elem.id,
          price: +elem.priceBaseWithDiscount
            ? +elem.priceBaseWithDiscount
            : +elem.priceBase,
          priceOld: +elem.priceBase,
          link,
          bx_id: elem.bx_id,
        }
      }),
    journal,
  }
}
